import Vue from 'vue';
import Vuex from 'vuex';
import AuthModule from './auth';
import SettingModule from './setting';
import NewsModule from './news';
import TeacherModule from './teacher';
import EmployeeModule from './employee';
import BookingModule from './booking';
import CourseModule from './course';
import HistoryModule from './history';
import FormModule from './form';
import ReviewModule from './review';
import ManageModule from './manage';
import TimetableModule from './timetable';
import ClaimModule from './claim';
import UnavailableModule from './unavailable';
import {UploadService} from '../services';
import {routeDefs} from '../routes';

Vue.use(Vuex);


export async function bindLoading(commit, action, ns = '', options = {delay: 200, ignoreGlobal: false}) {
    commit({
        type: 'saveLoading',
        loading: true,
        ns,
        ignoreGlobal: options.ignoreGlobal
    }, {root: true});

    await new Promise(resolve => {
        setTimeout(() => resolve(true), options.delay)
    });

    const result = await action();

    commit({
        type: 'saveLoading',
        loading: false,
        root: true,
        ns
    }, {root: true});
    return result;
}

export default new Vuex.Store({
    modules: {
        auth: AuthModule,
        setting: SettingModule,
        news: NewsModule,
        teacher: TeacherModule,
        booking: BookingModule,
        course: CourseModule,
        form: FormModule,
        history: HistoryModule,
        review: ReviewModule,
        manage: ManageModule,
        timetable: TimetableModule,
        claim: ClaimModule,
        employee: EmployeeModule,
        unavailable:UnavailableModule
    },
    state: {
        loading: {
            global: false,
            actions: {}
        },
    },
    getters: {
        menuDefs(state) {
            const filterFunc = r => r.show &&
                (r.claims.length <= 0 ||
                    r.claims.some(c => state.auth.claims.some(cc => cc === c))
                );
            const subMenusGrp = routeDefs
                .filter(r => r.parent)
                .filter(filterFunc)
                .reduce((grp, {title, path, exact, name, parent, checkOpen}) => {
                    (grp[parent]
                        = (grp[parent] || []))
                        .push({title, path, exact, name, checkOpen});
                    return grp;
                }, {});
            const topMenus = routeDefs
                .filter(r => !r.parent)
                .filter(filterFunc)
                .map(t => ({
                    ...t,
                    children: subMenusGrp.hasOwnProperty(t.name) ? subMenusGrp[t.name] : []
                }));
            return topMenus
                .map(({title, path, exact, name, children}) => ({title, path, exact, name, children}));
        }
    },
    mutations: {
        saveLoading(current, {loading, ns = '', ignoreGlobal = false}) {
            current.loading.global = ignoreGlobal ? false : loading;

            if (ns) {
                if (current.loading.actions.hasOwnProperty(ns)) {
                    current.loading.actions[ns] = loading;
                } else {
                    Vue.set(current.loading.actions, ns, loading);
                }
            }
        },
        resetLoading(current) {
            current.loading.global = false;
            Vue.set(current.loading, 'actions', {});
        }
    },
    actions: {
        async removeFileAction(_, {key, encrypted}) {
            await UploadService.removeFile({key, encrypted});
        },
        async downloadFileAction(_, payload) {
            const url = window.URL.createObjectURL(new Blob([await UploadService.download({
                f: payload.key
            })]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', payload.fullName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
    }
});